import { Theme } from '@mui/material';

import { varAlpha } from '@src/utils';

export const containerSx = (theme: Theme) => ({
  gap: 1,
  p: 1.25,
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  bgcolor: 'background.paper',
  borderTopLeftRadius: 'inherit',
  borderTopRightRadius: 'inherit',
  borderBottom: `solid 1px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.2)}`,
  '> div:first-of-type': {
    display: 'none', // 🩼🚲
  }
});

export const dividerSx = { height: 16, my: 'auto' };
